import { IS_PROD_ENV } from "@/constants/env";

export const LANDING_PAGE_URL = "https://zing.coach";
export const TERMS_OF_USE = {
    label: "Terms of Use",
    link: LANDING_PAGE_URL + "/terms-of-use",
};
export const PRIVACY_POLICY = {
    label: "Policy",
    link: LANDING_PAGE_URL + "/privacy-policy",
};

export const METHODOLOGY = {
    label: "Methodology",
    link: LANDING_PAGE_URL + "/methodology",
};

export const HOW_ZING_WORKS = {
    label: "How Zing Works",
    link: LANDING_PAGE_URL + "/how-zing-works",
};

export const JOBS_AT_ZING = {
    label: "Jobs at Zing",
    link: "https://boards.greenhouse.io/zing",
};

export const CONTACT_US = {
    label: "Contact Us",
    link: LANDING_PAGE_URL + "/contacts",
};

export const ZING_SUPPORT_MAIL = "support@zing.coach";
export const APP_STORE_LINK = "https://apps.apple.com/us/app/zing-ai-fitness-coach/id1552207792";
export const GOOGLE_PLAY_LINK =
    "https://play.google.com/store/apps/details?id=coach.zing.fitness&hl=en&gl=US&pli=1";
export const FACEBOOK_LINK = "https://www.facebook.com/Zing-AI-Fitness-Coach-100745681950404";
export const TWITTER_LINK = "https://twitter.com/coach_zing";
export const INSTAGRAM_LINK = "https://www.instagram.com/zing.coach/";
export const LINKEDIN_LINK = "https://www.linkedin.com/company/zing-fitness/mycompany/";
export const REFUND_POLICY_LINK = "https://zing.coach/refund-policy";
export const WEB_PORTAL_LINK = IS_PROD_ENV
    ? "https://portal.zing.coach"
    : "https://dev.portal.zing.coach";
export const SUPPORT_LINK = "https://zingcoach.zendesk.com/hc/en-us/requests/new";
export const FAQ_LINK = "https://zingcoach.zendesk.com/hc/en-us";
